<!--
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-05-11 23:23:19
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-05-16 14:52:02
-->
<template>
    <div>
        <van-field :rules="rules" :disabled="disabled">
            <template #input>
                <van-uploader
                    v-model="fileList"
                    :disabled="disabled"
                    :deletable="!disabled"
                    :max-count="verifyMax"
                    :after-read="handleAfterRead"
                    :before-delete="handleBeforeDelete"
                ></van-uploader>
            </template>
        </van-field>
        <p class="des" v-if="verifyMax != 9999">最多上传{{ verifyMax }} 张</p>
    </div>
</template>

<script>
import { uploadQiniu } from '@/utils/qiniu'
export default {
    name: 'E-seeclearlyUpload',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        rules: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        verifyMax: {
            type: [Number, String]
        }
    },
    data() {
        return {
            fileList: []
        }
    },
    computed:{
    },
    created() {
        this.fileList = this.value;
    },
    methods: {
        handleAfterRead(file) {
            const toast = this.$toast({
                type: 'loading',
                message: '上传中',
                forbidClick: true,
                duration:0
            })
            uploadQiniu(
                file.file,
                resolve => {
                    toast.clear();
                    file.url = resolve;
                    console.log(this.fileList)
                    this.$emit('input', this.fileList)
                    this.$emit('success')
                },
                () => {
                    toast.clear();
                    file.status = 'failed';
                    file.message = '上传失败';
                    this.$emit('input', this.fileList);
                    this.$emit('success');
                },
                progress => {
                    toast.message = Math.floor(progress) + '%'
                }
            )
        },

        handleBeforeDelete(file) {
            const result = this.fileList.filter(photo => photo.url !== file.url);
            console.log(result,this.fileList,file)
            this.fileList = result;
            this.$emit('input', result)
            this.$emit('delete')
        }
    }
}
</script>

<style scoped>
.des {
    padding: 0 16px 16px;
    font-size: 13px;
    font-weight: 400;
    color: #9EA2A8;
    line-height: 19px;
}
</style>
